import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { ConfigService } from '@valtimo/config';

@Injectable({
  providedIn: 'root',
})
export class DestructionProcedurePluginService {

  constructor(
    private http: HttpClient
    // configService: ConfigService
  ) { }
}
